import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';
export const findProductGoods= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v2/product?`+params,
        method: 'GET'
    })
}
export const addProductGoods = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v2/product`,
        method: 'POST',
        data: data
    })
}
export const updateProduct = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v2/product`,
        method: 'PUT',
        data: data
    })
}
export const delProduct = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v2/product/${id}`,
        method: 'DELETE'
    })
}




export const addShopGoods = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods/add`,
        method: 'POST',
        data: data
    })
}
export const findShopGoods = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods/findGoodsList?`+params,
        method: 'GET'
    })
}


export const findProductGoodsById= (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/product/findProductGoodsById/${id}`,
        method: 'GET'
    })
}
export const productDown = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-product/v1/product/productDown/${temp}`,
        method: 'PUT'
    })
}
export const productPutAway = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-product/v1/product/productPutAway/${temp}`,
        method: 'PUT'
    })
}
export const findProductSkuClassify= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/sku/list?`+params,
        method: 'GET'
    })
}
export const findConstituteBySkuId= (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/sku/constitute/${id}`,
        method: 'GET'
    })
}
export const findBrand = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/brand`,
        method: 'GET'
    })
}
export const findBrand1 = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/brand/choose`,
        method: 'GET'
    })
}
export const chooseSecondClassify = (id) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose?superiorId=${id}`,
        method: 'GET'
    })

}
export const findClassify = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose`,
        method: 'GET'
    })
}
export const findAllSuperiorDepartment = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
        method: 'GET'
    })
}
